import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs';
import { ToastService } from 'src/app/_metronic/shared/components/toast/toast.service';
import { AuthService } from '../../services/auth/auth.service';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { CheckEmailComponent } from './check-email/check-email.component';
import { ForgotPasswordFormComponent } from './forgot-password-form/forgot-password-form.component';
import { LinkExpiredComponent } from './link-expired/link-expired.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { SetPasswordFormComponent } from './set-password-form/set-password-form.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AuthLayoutComponent,
    LoginFormComponent,
    ForgotPasswordFormComponent,
    CheckEmailComponent,
    CheckEmailComponent,
    SetPasswordFormComponent,
    LinkExpiredComponent
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  currentView: 'login' | 'forgot-password' | 'check-email' | 'set-password' | 'link-expired' = 'login';
  submittedEmail: string = '';
  setPasswordMode: 'reset' | 'create' = 'reset';
  resetToken = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    // Check for query params
    this.route.queryParams.subscribe((params: any) => {
      const type = params['type'];
      const token = params['token'];
      const email = params['email'];

      if (token && (type === 'reset-password' || type === 'create-password')) {
        this.setPasswordMode = type === 'create-password' ? 'create' : 'reset';
        this.resetToken = token;
        if (email) this.submittedEmail = email;
        this.currentView = 'set-password';
      }
    });
  }

  showForgotPassword(): void {
    this.currentView = 'forgot-password';
  }

  showCheckEmail(email: string): void {
    this.submittedEmail = email;
    this.currentView = 'check-email';
  }

  backToLogin(): void {
    this.currentView = 'login';
  }

  handleMicrosoftLogin(): void {
    // Redirect to the authorize route which is protected by MsalGuard
    this.router.navigate(['/authorize']);
  }

  handleResendEmail(): void {
    // Logic to resend email via API
    this.authService.requestForgotPassword(this.submittedEmail).pipe(take(1)).subscribe({
        next: () => {
            this.cdr.detectChanges();
        },
        error: (err) => {
            console.error('Forgot Password Error:', err); // Log for debugging
            const errorMsg = err?.error?.message || 'Failed to request password reset';
            this.toastService.error(errorMsg);
            this.cdr.detectChanges();
        }
    });
  }

  handlePasswordSetSuccess(): void {
    // Remove query params and go back to login
    this.router.navigate(['/login'], { replaceUrl: true });
    this.currentView = 'login';
  }

  handleLinkExpired(): void {
    this.currentView = 'link-expired';
  }
}
